<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'450'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>
                    Alterar Método Http
                </span>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span>
                    Selecione um método HTTP para a requisição {{requisicaoEditar.id}}:
                </span>

                <br>
                <br>
                <v-select :name="'Method' + requisicaoEditar.id" :key="'Method' + requisicaoEditar.id" label="Method" placeholder="Selecione"
                          :menu-props="{top: false, offsetY: true}"
                          v-model="metodo" class="required-field" v-validate="'required'"
                          :items="Object.entries(metodosHttp).map(([key, value]) => ({key: value.valor, value: value.texto}))"
                          :error-messages="errors.collect('Method' + requisicaoEditar.id)" item-text="value" item-value="key"/>
            </v-card-text>

            <v-card-actions>
                <v-flex>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoConfirmar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoFechar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {metodosHttp} from '@/core/constants'
export default {
    name: 'ModalEditarMetodoRequisicao',
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        }
    },
    data(){
        return{
            metodosHttp,
            metodo: null
        }
    },
    mounted(){
        this.metodo = this.requisicaoEditar.method
    },
    methods:{
        confirmar() {
            this.requisicaoEditar.method = this.metodo
            this.$emit('confirmar', this.requisicaoEditar)
        }
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important

</style>
